<template>
<div style="height: 100%; width: 100%;">
    <v-layout row style="height: 100%; width: 100%; padding: 10px; padding-right: 20px;">
      <!-- <v-flex xs12 style="height: height:100vh; width: 100%;">
        <img alt="ORR Logo" height="70px" src="../assets/orr/logo.png" />
        <filters />
      </v-flex> -->
      <v-flex xs12 style="height: height:100vh; width: 100%; padding: 10px; padding-left: 30px;">
         <v-layout row justify-end>
           <v-flex style="margin-bottom: 10px">
           <v-btn-toggle v-model="display">
              <v-btn flat value="annotated">
                Annotated Facts
              </v-btn>
              <v-btn flat value="forecast">
                Forecast
              </v-btn>
              <v-btn flat value="heatmap">
                Heatmap
              </v-btn>
              <v-btn flat value="wordcloud">
                Word Cloud
              </v-btn>
              <v-btn flat value="cluster">
                Cluster
              </v-btn>
              <v-btn flat value="slider">
                Slider
              </v-btn>
            </v-btn-toggle>
            </v-flex>
         </v-layout>
        <annotated-chart style="height: 450px; width: 100%;" v-if="display == 'annotated'" />
        <forecast-chart style="height: 450px; width: 100%;" v-if="display == 'forecast'" />
        <heatmap-chart style="height: 95%; width: 100%;" v-if="display == 'heatmap'" />
        <wordcloud-chart style="height: 95%; width: 100%;" v-if="display == 'wordcloud'" />
        <cluster-chart style="height: 95%; width: 100%;" v-if="display == 'cluster'" />
        <orr-slider style="height: 95%; width: 100%;" v-if="display == 'slider'" />
      </v-flex>
    </v-layout>
</div>
</template>

<script>
import dataSources from "@/store/modules/data-sources";
import charts from "@/store/modules/charts";
const AnnotatedChart = () => import('@/components/charts/orr/annotated.vue');
const ForecastChart = () => import('@/components/charts/orr/forecast.vue');
const HeatmapChart = () => import('@/components/charts/orr/heatmap.vue');
const WordcloudChart = () => import('@/components/charts/orr/wordcloud.vue');
const ClusterChart = () => import('@/components/charts/orr/cluster.vue');
const OrrSlider = () => import('@/components/charts/orr/selectors.vue');

const Filters = () => import('@/components/charts/orr/filters.vue');
export default {
  data() {
        return {
          display: 'annotated',
        }
    },
    components: {
      AnnotatedChart,
      ForecastChart,
      HeatmapChart,
      WordcloudChart,
      ClusterChart,
      OrrSlider,
      Filters,
    },
    beforeMount() {

    },
    beforeCreate: function () {
    // this.$store.registerModule('dataSources', dataSources);
    if (typeof this.$store.state["dataSources"] == "undefined") {
      this.$store.registerModule("dataSources", dataSources);
    }
    if (typeof this.$store.state["charts"] == "undefined") {
      this.$store.registerModule("charts", charts);
    }
    // this.$store.registerModule('charts', charts);
  },
}
</script>
